import Panel from '@admin/components/panel'
import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

class Notifications extends React.Component {

  static propTypes = {
    notifications: PropTypes.array
  }

  render() {
    const { notifications } = this.props
    return (
      <div className="maha-notification-types">
        { notifications.map((app, index) => [
          <div className="maha-notification-types-app" key={`app_${index}`}>
            <div className="maha-notification-types-app-icon">
              <Icon icon={`${app.icon}`} />
            </div>
            { app.title }
          </div>,
          app.items.map((item, i) => (
            <div className="maha-notification-types-notification" key={`notification_${i}`}>
              <div className="maha-notification-types-notification-label">
                { item.description }<br />
              </div>
              <div className="maha-notification-types-notification-methods">
                <div className="maha-notification-types-notification-method-display">
                  <i className={ this._getChecked(item, 'inapp') } />
                  In App
                </div>
                <div className="maha-notification-types-notification-method-display">
                  <i className={ this._getChecked(item, 'push') } />
                  Push
                </div>
                <div className="maha-notification-types-notification-method-display">
                  <i className={ this._getChecked(item, 'email') } />
                  Email
                </div>
              </div>
            </div>
          ))
        ])}
      </div>
    )
  }

  _getChecked(notification, method) {
    return notification[`${method}_enabled`] ? 'fa fa-check-circle' : 'fa fa-circle-o'
  }

}

const mapResourcesToPanel = (props, context) => ({
  notifications: `/api/admin/team/users/${props.user.id}/notifications`
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Notifications)',
  panel: <Notifications notifications={ props.notifications } />
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)
